import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';

interface ValueProps {
  active: boolean;
}

interface ValueProps2 {
  height: string;
  border?: boolean;
}

interface ValueProps3 {
  top?: string;
}


export const Container = styled.section<ValueProps2>`
  background: ${({ theme }) => theme.searchInput.travelArranger.background};
  color: ${({ theme }) => theme.searchInput.travelArranger.label.color};
  box-shadow: ${({ theme }) => theme.searchInput.travelArranger.boxShadow};
  
  height: ${(props: ValueProps2) => props.height ? `${props.height};` : '75px'};

  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.searchInput.travelArranger.padding};
  position: relative;
  border-radius: 8px;
  border: ${(props: ValueProps2) => props.border ? '2px solid rgba(184, 180, 180, 0.25);' : ({ theme }) => theme.searchInput.travelArranger.border}; 
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Content = styled.button`
  background: none;  
`;

export const Label = styled.span<ValueProps3>`
  position: absolute;
  top: ${(props: ValueProps3) => props.top ? `${props.top};` : ({ theme }) => theme.searchInput.travelArranger.detail.top};

  font-size: ${({ theme }) => theme.searchInput.travelArranger.detail.fontSize};
  line-height: unset;
  color: ${({ theme }) => theme.searchInput.travelArranger.detail.color};
  display: ${({ theme }) => theme.searchInput.travelArranger.detail.display};
`;

export const Value = styled.span<ValueProps>`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.searchInput.travelArranger.label.fontSize};
  ${_ellipsis()};
  line-height: unset;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.travelArranger.label.color : theme.searchInput.travelArranger.placeholder.label.color};
  font-weight: ${({ active }) => (active ? '600' : 'normal')};
  margin-top: 17px;
`;
/* margin-top: ${({ theme }) => theme.searchInput.travelArranger.label.marginTop}; */
export const GuestTag = styled.p`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.searchInput.travelArranger.guest.fontSize};
  line-height: 1.29;
  margin-left: 10px;
  font-weight: normal;
  color: ${({ theme }) => theme.searchInput.travelArranger.guest.color};
`;

export const RadioButtonsContainer = styled.div`
  justify-content: space-between;
`;

export const Row = styled.div`
  display: inline-flex;
  padding-left: 20px;
`;

export const RadioButtonLabel = styled.div`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.2px;
  margin-left: 12px;
  color: ${({ theme }) => theme.group.subTitle};
`;

/****************************** */

export const TravelKindRowContainer: any = styled.section`
  display: flex;
  justify-content: space-around;  

  @media ${({ theme }) => theme.device.desktop} {
    width: 50%;
  }
`;

TravelKindRowContainer.CheckboxContainer = styled.div`
  display: flex;  

  &:not(:first-child) {
    padding-left: 20px;
  }

  & > span {
    margin-left: 8px;
    color: ${({ theme }) => theme.flightSearch.kindLabel};
  }
`;

TravelKindRowContainer.label = styled.span`
  font-size: 12px;
`;